import { useMutation } from '@tanstack/react-query'

import { authApi } from '../api/authApi'
import type { TMePayload } from '../api/types/mePayload.types'

export const useMeMutation = () => useMutation({ mutationFn: (meUpdates: TMePayload) => authApi.patchMe(meUpdates) })
